import React, { useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import Modal from 'react-modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import 'react-toastify/dist/ReactToastify.css';

Modal.setAppElement('#root'); // Установка root элемента для модального окна

const LoginForm = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [isForgotModalOpen, setIsForgotModalOpen] = useState(false); // Состояние модального окна
  const [email, setEmail] = useState(''); // Состояние для email в модалке

  // Обработчик формы входа
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const response = await fetch('/session', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ username, password }),
    });

    const data = await response.json();
    setLoading(false);

    if (data.success) {
      toast.success(data.message, { position: 'top-center' });
      window.location.href = '/reports'; // Перенаправление на страницу
    } else {
      toast.error(data.message, { position: 'top-center' });
    }
  };

  // Обработчик отправки email для сброса пароля
  const handleForgotPassword = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await fetch('/session/forgot_password', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();
      setLoading(false);

      if (data.success) {
        toast.success('Инструкции по сбросу пароля отправлены на ваш email.', { position: 'top-center' });
        setIsForgotModalOpen(false); // Закрываем модалку после успешной отправки
      } else {
        toast.error(data.message, { position: 'top-center' });
      }
    } catch (error) {
      setLoading(false);
      toast.error('Ошибка при отправке запроса. Попробуйте снова.', { position: 'top-center' });
    }
  };

  return (
    <div className="min-h-screen bg-blue-800 flex justify-center items-center p-4">
      <form
        className="py-8 px-8 bg-white rounded-2xl shadow-xl  w-full max-w-sm"
        onSubmit={handleSubmit}
      >
        <div>
          <h1 className="text-3xl font-bold text-center mb-4 cursor-pointer">Авторизация</h1>
          <p className="w-full text-center text-sm mb-8 font-semibold text-gray-700 tracking-wide cursor-pointer">
            Введите свои учетные данные для доступа к системе.
          </p>
        </div>

        <div className="space-y-4">
          <input
            type="text"
            placeholder="Имя пользователя"
            className="block text-sm py-3 px-4 rounded-lg w-full border outline-blue-500"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />

          <div className="relative">
            <input
              type={showPassword ? 'text' : 'password'}
              placeholder="Пароль"
              className="block text-sm py-3 px-4 rounded-lg w-full border outline-blue-500"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              className="absolute right-4 top-3 text-gray-500"
            >
              <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} size="lg" />
            </button>
          </div>
        </div>

        <div className="text-center mt-6">
          <button
            type="submit"
            className="w-full py-2 text-xl text-white bg-blue-800 rounded-lg hover:bg-blue-900 transition-all"
            disabled={loading}
          >
            Войти
          </button>
          <p className="mt-4 text-sm">
            <a
              className="underline cursor-pointer"
              onClick={() => setIsForgotModalOpen(true)}
            >
              Забыли пароль?
            </a>
          </p>
        </div>
      </form>

      {/* Модальное окно для "Забыли пароль?" */}
      <Modal
        isOpen={isForgotModalOpen}
        onRequestClose={() => setIsForgotModalOpen(false)}
        className="bg-white p-6 rounded shadow-md max-w-md mx-auto mt-20"
        overlayClassName="fixed inset-0 bg-gray-500 bg-opacity-75"
      >
        <h2 className="text-xl font-semibold mb-4">Сброс пароля</h2>
        <p className="mb-6 text-gray-700">
          Введите ваш email, чтобы получить инструкции по сбросу пароля.
        </p>
        <form onSubmit={handleForgotPassword}>
          <div className="mb-4">
            <input
              type="email"
              placeholder="Ваш email"
              className="block text-sm py-3 px-4 rounded-lg w-full border outline-blue-500"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div className="flex justify-end">
            <button
              type="button"
              onClick={() => setIsForgotModalOpen(false)}
              className="mr-2 rounded bg-gray-300 px-4 py-2"
            >
              Отмена
            </button>
            <button
              type="submit"
              className="rounded bg-blue-800 px-4 py-2 text-white hover:bg-blue-900"
              disabled={loading}
            >
              Отправить
            </button>
          </div>
        </form>
      </Modal>

      <ToastContainer />
    </div>
  );
};

export default LoginForm;
